import { Component } from '@angular/core';
import { isFormChange, onTypeChange } from 'app/core/shared/helper/equipment-registration.helper';
import { FormComponent } from 'app/modules/equipment-registration/component/form-component/form.component';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';
import { Annulus } from 'app/modules/equipment-registration/model/annulus.model';
import { EquipRegistrationServices } from 'app/modules/equipment-registration/services/equipment-registration.service';

@Component({
  selector: 'app-annulus-d',
  templateUrl: './annulus-d.component.html',
  standalone: true,
  imports: [
    ...module,
    FormComponent
  ],
  styleUrls: ['./annulus-d.component.scss']
})
export class AnnulusDComponent {
  public equipmentRegistration$ = this.equipmentServices.equipmentRegistration$
  public annulusD: Annulus = new Annulus();
  public tempAnnulusD: Annulus = new Annulus();
  public isReplace: boolean = true;
  public disabledToggle: boolean = true;

  constructor(
    private equipmentServices: EquipRegistrationServices
  ) { }

  ngOnInit() {
    this.initializeAnnulusForm()

    this.equipmentRegistration$.subscribe(wellEquipment => {
      if (!wellEquipment) return '';

      if (wellEquipment?.annulusD) {
        this.annulusD = new Annulus(wellEquipment?.annulusD);
      } else {
        this.initializeAnnulusForm()
      }

      this.handleFormValue()
      this.annulusD.wellStringId = wellEquipment.wellStringId
      this.tempAnnulusD.wellStringId = wellEquipment.wellStringId
      this.isReplace = !wellEquipment?.annulusD;
      this.disabledToggle = !wellEquipment?.annulusD;
    })
  }

  private handleFormValue() {
    if (!this.annulusD.mdSceValveTypeId) {
      this.setSceValveTypeId()
    }

    this.tempAnnulusD = new Annulus(this.annulusD)
  }

  private initializeAnnulusForm(): void {
    this.annulusD.reset()
  }

  private setSceValveTypeId() {
    this.equipmentServices.getSceValveTypeId('CCV').subscribe(id => {
      this.annulusD.mdSceValveTypeId = this.tempAnnulusD.mdSceValveTypeId = id
    })
  }

  disabledSave(): boolean {
    return !this.annulusD.wellStringId && !this.annulusD.mdSceValveTypeId || isFormChange(this.annulusD, this.tempAnnulusD)
  }

  save() {
    onTypeChange(this.annulusD)

    const operation = this.isReplace ?
      this.equipmentServices.addSceWellhead(this.annulusD) :
      this.equipmentServices.updateSceWellhead(this.annulusD);

    operation.subscribe((res) => {
      if (res) {
        this.equipmentServices.getEquipmentRegistration(this.annulusD.wellStringId).subscribe();
      }
    });
  }
}
